var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#expand_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    fillRule: "evenodd",
    d: "M4.688 0h14.625A4.696 4.696 0 0 1 24 4.688v14.625A4.696 4.696 0 0 1 19.313 24H4.688A4.696 4.696 0 0 1 0 19.313V4.688A4.697 4.697 0 0 1 4.688 0m.28 18.152a.88.88 0 0 0 .88.88h4.6a.88.88 0 1 0 0-1.759H7.97l3.272-3.271a.88.88 0 0 0-1.244-1.244l-3.271 3.273v-2.479a.879.879 0 0 0-1.758 0zM19.032 5.848a.88.88 0 0 0-.879-.88h-4.6a.88.88 0 1 0 0 1.759h2.479l-3.273 3.271a.879.879 0 1 0 1.244 1.244l3.271-3.273v2.479a.88.88 0 0 0 1.758 0z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "expand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgExpand;